import { MultiSelect } from 'primereact/multiselect';
import React from 'react';
import "components/shared/mu-select/style.scss";

/**
 * 
 * @param {Object} props { optionLabel, value, options, onChange, placeholder } 
 * @returns React.Component
 */
export const MulSelect = (props) => {
    return (
        <div className="p-inputgroup my-2">
            {
                props.icon &&
                <span className="p-inputgroup-addon">
                    <i className={props.icon}></i>
                </span>
            }
            <MultiSelect {...props} />
        </div>
    );
}